import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router';
import Cookies from 'universal-cookie';
import ToastError from '../Toasts/ToastError';

const UnauthorizedEventListener = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();
  const eventListenerAdded = useRef(false);
  const tokenName = "token";

  const allowedRoutes = ["/login", "/wachtwoord-vergeten", "/wachtwoord-resetten"];

  // Handle the case when the user is unauthorized
  const handleUnauthorized = (event) => {
    const inactiveSubscription = event.detail?.inactiveSubscription;

    if (inactiveSubscription === false) {
      ToastError("Je omgeving is geblokkeerd contacteer ons als je deze wilt verlengen.", "unauthorized-event");
    } else {
      ToastError("Je sessie is verlopen of je hebt geen toegang. Je wordt nu doorgestuurd naar de login pagina.", "unauthorized-event");
    }
    cookies.remove(tokenName, { path: '/' });
    redirectUser();
  };

  const redirectUser = () => {
    // Get existing URL parameters
    const params = new URLSearchParams(window.location.search);
    
    // Add redirect parameter if not on homepage
    if (location.pathname !== "/") {
      params.set('redirect', location.pathname);
    }
    
    // Build the login URL with all parameters
    const loginUrl = '/login' + (params.toString() ? '?' + params.toString() : '');
    
    navigate(loginUrl);
  }

  useEffect(() => {
    if (eventListenerAdded.current) return; // Prevent multiple listeners
    eventListenerAdded.current = true;

    // Skip the token check for allowed routes
    if (allowedRoutes.includes(location.pathname)) {
      return;
    }

    // Attach unauthorized event listener
    window.addEventListener('unauthorized-event', handleUnauthorized);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('unauthorized-event', handleUnauthorized);
      eventListenerAdded.current = false;
    };
  }, [navigate, location.pathname, cookies]);

  return null;
};

export default UnauthorizedEventListener;